import { useNavigate } from 'react-router-dom';
import { Api } from 'src/api';

import ProjectsAction from './ProjectsAction';

type Props = {
  company: Api.Company.BaseView;
  /** The project the new order forms part of, where it was asked for under one. */
  project?: { id: string } | null;
  /** Under a project, indented to sit with the orders beneath it. */
  level: 'project' | 'card';
};

/**
 * The row that opens the New Service Order screen, carrying the client and
 * project the order will belong to.
 */
export default function NewServiceOrderAction({
  company,
  project,
  level,
}: Props) {
  const navigate = useNavigate();

  const query = new URLSearchParams({ company: company.id });
  if (project) query.set('project', project.id);

  return (
    <ProjectsAction
      label="New service order"
      level={level}
      onClick={() => navigate(`/projects/service-orders/new?${query}`)}
    />
  );
}
